export default __webpack_public_path__ + "static/media/sports.327df874.png";